import styled, { css } from 'styled-components';

export const StyledBlock = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  ${({ hasNotifications }) =>
    hasNotifications &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: -1px;
        right: -1px;
        z-index: 1;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.color.brightTurquoise};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.color.white};
      }
    `}
`;
